import {Injectable} from '@angular/core';
import {EntityState, EntityStore, StoreConfig} from '@datorama/akita';
import {PressNews} from './model';

export interface PressNewsState extends EntityState<PressNews> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'PressNews' })
export class Store extends EntityStore<PressNewsState> {

  constructor() {
    super();
  }

}
